import * as React from 'react'
import { useMemo } from 'react'
import { MatchPairProps } from '../../typings'
import { SelectionHeader } from '../../atoms'
import {
  LocationMatch,
  locationToLocationDTO,
} from '@user/store/entityLocations'
import { useToggleBoolean } from '@user/utils/useToggleBoolean'
import { SmallLocationCard } from '@user/components/Location'

type Props = MatchPairProps & {
  match: LocationMatch & {
    createNewLocation: false
  }
}

export const MatchBody: React.FC<Props> = (props) => {
  const {
    match: { externalEntityId },
    state: { externalLocations },
  } = props

  const [open, toggleOpen] = useToggleBoolean()

  const matchedLocation = useMemo(() => {
    const externalLocation = externalLocations.find(
      (x) => x.id === externalEntityId,
    )

    return !!externalLocation
      ? locationToLocationDTO(externalLocation)
      : undefined
  }, [externalEntityId, externalLocations])

  return !!matchedLocation ? (
    <SmallLocationCard
      {...props}
      location={matchedLocation}
      isEditable={false}
      open={open}
      toggleOpen={toggleOpen}
      hidePopover
      header={<SelectionHeader {...props} />}
    />
  ) : null
}
MatchBody.displayName = 'MatchBody'
